<label class="db">{{labelText}}</label>
<p-inputGroup class="">
  <input [type]="inputType" pInputText
    [(ngModel)]="ngModelData"
    (ngModelChange)="ngModelDataChange.emit($event)"
    class="form-control"
    [formControl]="control"
    [placeholder]="placeholderText" />
  <p-inputGroupAddon class="cp" (click)="onClickInputGroup()" pTooltip="Generate Track Number">
    <i class="pi pi-refresh cp {{isLoading?'pi-spin':''}} "></i>
  </p-inputGroupAddon>
</p-inputGroup>
<app-validator-error [control]="controlValidation" ></app-validator-error>
